<script lang="ts" setup>
import Toast from 'primevue/toast'
import Breadcrumb from 'primevue/breadcrumb'
import Header from '@/components/global/header/Header.vue'
import Sidebar from '@/components/global/sidebar/Sidebar.vue'

import { Icon } from '@iconify/vue'
import { useRoute } from 'vue-router'
import { getToastIcon } from '@/utils'
import type { MenuItem } from 'primevue/menuitem'

const currentRoute: MenuItem = useRoute()
</script>

<template>
  <Toast>
    <template #icon="slotProps">
      <Icon :icon="getToastIcon(slotProps.class)" class="text-xl" />
    </template>
  </Toast>
  <div class="flex flex-col justify-between min-h-screen bg-neutral-100/70 text-neutral-900">
    <main class="flex-1 flex">
      <Sidebar />
      <div class="flex-1">
        <Header />
        <div class="p-6">
          <Breadcrumb :model="currentRoute.meta?.breadcrumb || []" />

          <slot></slot>
        </div>
      </div>
    </main>
  </div>
</template>
